import { useRoute, type RouteProp } from '@react-navigation/native';
import { createStore, Provider } from 'jotai';
import { useLayoutEffect, type ReactNode } from 'react';
import { type FilterListAtom } from './filterList.atom';
import { useFilterListAtom } from './useFilterListAtom';

export const filterListStore = createStore();

type Props = {
  children:
    | ((props: { filterListState: FilterListAtom }) => ReactNode)
    | ReactNode;
};

const InitializeStore = ({ children }: Props) => {
  const { params } = useRoute<
    RouteProp<{
      params: Partial<FilterListAtom>;
    }>
  >();
  const { setFilterListAtom } = useFilterListAtom();

  useLayoutEffect(() => {
    const newParams = {
      ...params,
      // next_token은 저장하지 않는다.
      next_token: undefined,
      instanceId: undefined,
    };
    setFilterListAtom(newParams);
  }, [params, setFilterListAtom]);

  return <>{children}</>;
};

/**
 * - FILTER_LIST atomic을 사용하기 위해 필요한 provider
 * - route params에서 instanceId를 가져와서 각 FilterList가 독립적인 상태를 가지도록 함
 */
export const FilterListAtomProvider = ({ children }: Props) => {
  return (
    <Provider store={filterListStore}>
      <InitializeStore>{children}</InitializeStore>
    </Provider>
  );
};
